import { useInView, useMounted } from 'shared/hooks/utils';
import { useAction, useAppSelector, usePartialAppSelector, } from 'shared/hooks/redux/hooks';
import { loadTrack } from 'entities/device.map.track/model/actions';
import { selectDeviceTrack } from 'entities/device.map.track/lib/selectors';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAPI } from 'console/shared/api/api-context';
import { throttle } from 'throttle-debounce';
import { ZONTGeocoding } from 'console/shared/api/geocoding';
import { getStaleState } from 'console/idle/selectors';
export const useLoadMapTrack = (device_id) => {
    const { mintime, maxtime } = useAppSelector((state) => state.period);
    const isMounted = useMounted();
    const tracking_state = usePartialAppSelector(selectDeviceTrack, device_id);
    const onLoadTrack = useAction(loadTrack);
    const stale = useAppSelector(getStaleState);
    useEffect(() => {
        if (isMounted.current) {
            if (tracking_state) {
                //Если ошибка в загрузке трека, то, чтобы не грузить тот же трек
                if (tracking_state.error != null &&
                    mintime == tracking_state?.mintime &&
                    maxtime == tracking_state?.maxtime) {
                    return;
                }
                //Если трек загружается
                if (tracking_state.loading) {
                    return;
                }
            }
            //Если поменяли период, то надо забросить новый трек!
            if (mintime != tracking_state?.mintime ||
                maxtime != tracking_state?.maxtime ||
                (!tracking_state?.loading && !tracking_state?.raw_data)) {
                onLoadTrack(device_id, mintime, maxtime);
            }
        }
    }, [device_id, mintime, maxtime, tracking_state]);
    useEffect(() => {
        if (isMounted.current && !stale && tracking_state) {
            onLoadTrack(device_id, mintime, maxtime);
        }
    }, [stale]);
};
const useVehicleAddress = (device_id, throttleTimeout) => {
    const [address, setAddress] = useState([]);
    const isMounted = useMounted();
    const api = useAPI();
    const getAddress = useCallback(async (locs) => {
        if (locs) {
            ZONTGeocoding.geocode_many_and_extract_promise(api, [locs], 'state-tab').then((results) => {
                if (isMounted.current) {
                    setAddress(results);
                }
            });
        }
    }, [setAddress, api, setAddress]);
    const throttledRequestAddress = useMemo(() => (throttleTimeout ? throttle(throttleTimeout, getAddress) : getAddress), [device_id, throttleTimeout]);
    return [address, throttledRequestAddress];
};
export const useCurrentVehicleAddress = (device_id, locs, throttleTimeout) => {
    const [address, addressRequest] = useVehicleAddress(device_id, throttleTimeout);
    useEffect(() => {
        addressRequest(locs);
    }, [locs]);
    return address;
};
export const useEventVehicleAddress = (device_id, locs) => {
    const [in_view, ref_in_view] = useInView();
    const [address, addressRequest] = useVehicleAddress(device_id);
    useEffect(() => {
        if (in_view) {
            addressRequest(locs);
        }
    }, [in_view]);
    return [ref_in_view, address];
};
